export default "__VITE_ASSET__Bkj$XfNn__"